// removed by extract-text-webpack-plugin
module.exports = {"root":"_1_JgR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Breadcrumbs/Breadcrumbs.css
// module id = 733
// module chunks = 0